<script>
  import { Radar } from 'vue-chartjs'

  export default {
    extends: Radar,

    props: {
        labels: { type: Array },
        data: { type: Array }
    },

    data () {
      return {
        chartData: {
          /*labels: [
             "Babol",	
             "Cabanatuan",	
             "Daegu",	
             "Jerusalem",	
             "Fairfield",	
             "New York",
             "Gangtok", 
             "Buenos Aires", 
             "Hafar Al-Batin", 
             "Idlib"
          ],*/
          labels: this.labels,
          datasets: [
            {
              label: '',
              borderWidth: 1,
              backgroundColor: 'rgba(54, 162, 235, 0.2)',
              /*data: [
                32127289, 
                24724027, 
                25820412, 
                23685667, 
                25644258, 
                22433220, 
                22966210, 
                22743184, 
                21880515, 
                21543111
              ]*/
              data: this.data
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false
        }
      }
    },
    mounted () {
      this.renderChart(this.chartData, this.options)
    }
  }
</script>